import store from '@/store';
import resourcesApi from "@/api/resources/resourcesApi";

export const ProjectDocumentationHelper = {
    async getProjectHasDocumentsInfo() {
        let workSession = await store.getters.getActiveWorkSession;

        /* Check if the work session and project id is set exists */
        if (workSession &&
            (workSession.project_settings != null && (workSession.project_settings.project_id != undefined && workSession.project_settings.project_id != null))
        ) {

            let lastCheck = await store.getters.getLastProjectDocumentationCheck;
            //DIVIDE BY 1000 FOR SECONDS INSTEAD OF MILLISECONDS
            let now = Math.floor(Date.now() / 1000);
            let targetTiming = now - (5 * 60); //SUBTRACT 5 MIN ... this is the wait time for a refresh

            if (targetTiming >= lastCheck) {
                let data = await resourcesApi.getProjectHasDocumentsInfo(workSession.project_settings.project_id)
                    .then(response => {
                        return response.data;
                    }).catch((error) => {
                        window.console.error(error);
                        return undefined;
                    });


                if (data != undefined && data.has_documents != undefined && data.has_documents != null) {
                    await store.dispatch('setProjectHasDocumentsInfo', data.has_documents);
                }
            }/* else {
                window.console.log('**** Recently checked ****');
            }*/
        } else {
            //window.console.log('**** NO SESSION DATA OR PROJECT ID FOUND NOT EXECUTING ****');
            await store.dispatch('clearProjectHasDocumentsInfo');
        }
    }
}